/****

const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelectorAll(".js-color-swatches-link")
						.forEach((item) =>
							item.setAttribute("href", event.currentTarget.dataset.variantLink)
						);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src)
											.pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src)
											.pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

(function () {
	colorSwatches();
})();

***/



console.log('🎨 Product card script loaded');

const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const updateProductImage = (wrapper, input) => {
	console.log('\n🖱️ updateProductImage called');
	console.log('  Value:', input.value);
	console.log('  Checked:', input.checked);
	
	const primaryImage = wrapper.querySelector(".media--first");
	const secondaryImage = wrapper.querySelector(".media--second");
	const handleProduct = wrapper.dataset.product;
	
	console.log('  Primary image:', !!primaryImage);
	console.log('  Product handle:', handleProduct);
	
	if (!input.checked || !primaryImage || !handleProduct) {
		console.log('❌ Conditions not met, aborting');
		return;
	}
	
	console.log('✅ Updating links and fetching product...');
	
	// Update all links
	wrapper.querySelectorAll(".js-color-swatches-link").forEach((item) => {
		item.setAttribute("href", input.dataset.variantLink);
	});
	
	const currentColor = input.value;
	
	fetch(window.Shopify.routes.root + `products/${handleProduct}.js`)
		.then(response => response.json())
		.then(product => {
			console.log('  Product fetched:', product.title);
			
			const variant = product.variants.find(
				(item) => item.featured_media != null && item.options.includes(currentColor)
			);
			
			if (!variant) {
				console.log('❌ No variant found with media for:', currentColor);
				return;
			}
			
			console.log('✅ Variant found:', variant.id);
			
			const newPrimaryImage = createImageElement(
				variant.featured_media,
				primaryImage.className,
				primaryImage.sizes,
				product.title
			);
			
			if (newPrimaryImage.src === primaryImage.src) {
				console.log('ℹ️ Same image, no swap needed');
				return;
			}
			
			console.log('🔄 Swapping images...');
			
			// Check if secondary image matches new primary
			if (secondaryImage) {
				const secondaryPath = new URL(secondaryImage.src).pathname;
				const newPrimaryPath = new URL(newPrimaryImage.src).pathname;
				if (secondaryPath === newPrimaryPath) {
					console.log('  Using secondary as new primary');
					primaryImage.remove();
					secondaryImage.classList.remove("media--second");
					secondaryImage.classList.add("media--first");
					return;
				}
			}
			
			// Swap with animation
			primaryImage.style.transition = 'opacity 0.2s ease-in';
			primaryImage.style.opacity = '0';
			
			setTimeout(() => {
				primaryImage.replaceWith(newPrimaryImage);
				newPrimaryImage.style.transition = 'opacity 0.2s ease-in';
				newPrimaryImage.style.opacity = '0';
				
				requestAnimationFrame(() => {
					newPrimaryImage.style.opacity = '1';
				});
				
				if (secondaryImage) {
					secondaryImage.remove();
				}
				
				console.log('✅ Image swap complete');
			}, 200);
		})
		.catch(error => {
			console.error('❌ Fetch error:', error);
		});
};

// Store timeout IDs for each wrapper to prevent flickering
const hoverTimeouts = new WeakMap();

// Disable hover effect when hovering over swatches or card-information area
document.addEventListener('mouseenter', function(e) {
	const swatches = e.target.closest('.js-color-swatches');
	const cardInfo = e.target.closest('.card-information');
	const productParams = e.target.closest('.product-parameters');
	
	if (swatches || cardInfo || productParams) {
		const wrapper = e.target.closest('.js-color-swatches-wrapper');
		if (wrapper) {
			// Clear any pending timeout for this wrapper
			if (hoverTimeouts.has(wrapper)) {
				clearTimeout(hoverTimeouts.get(wrapper));
				hoverTimeouts.delete(wrapper);
			}
			
			const card = wrapper.querySelector('.card--product');
			const mediaContainer = wrapper.querySelector('.media');
			if (card) {
				console.log('🚫 Disabling hover effect on card');
				card.classList.add('no-hover-effect');
			}
			if (mediaContainer) {
				mediaContainer.classList.add('no-hover-effect');
			}
		}
	}
}, true);

document.addEventListener('mouseleave', function(e) {
	const swatches = e.target.closest('.js-color-swatches');
	const cardInfo = e.target.closest('.card-information');
	const productParams = e.target.closest('.product-parameters');
	
	if (swatches || cardInfo || productParams) {
		const wrapper = e.target.closest('.js-color-swatches-wrapper');
		if (wrapper) {
			// Clear any existing timeout
			if (hoverTimeouts.has(wrapper)) {
				clearTimeout(hoverTimeouts.get(wrapper));
			}
			
			// Set a delay before re-enabling hover effect
			const timeoutId = setTimeout(() => {
				const card = wrapper.querySelector('.card--product');
				const mediaContainer = wrapper.querySelector('.media');
				if (card) {
					console.log('✅ Re-enabling hover effect on card');
					card.classList.remove('no-hover-effect');
				}
				if (mediaContainer) {
					mediaContainer.classList.remove('no-hover-effect');
				}
				hoverTimeouts.delete(wrapper);
			}, 150); // 150ms delay to account for mouse moving between swatches
			
			hoverTimeouts.set(wrapper, timeoutId);
		}
	}
}, true);

// Use event delegation on document level - this works immediately and catches all clicks
document.addEventListener('click', function(e) {
	// Check if click is on a swatch input or label
	let input = null;
	let wrapper = null;
	
	if (e.target.matches('.js-color-swatches input[type="radio"]')) {
		// Direct click on input
		console.log('🎯 Direct input click detected');
		input = e.target;
		wrapper = input.closest('.js-color-swatches-wrapper');
	} else if (e.target.matches('.js-color-swatches label') || e.target.closest('.js-color-swatches label')) {
		// Click on label
		console.log('🏷️ Label click detected');
		const label = e.target.matches('label') ? e.target : e.target.closest('label');
		const forId = label.getAttribute('for');
		input = document.getElementById(forId);
		wrapper = label.closest('.js-color-swatches-wrapper');
		
		if (input) {
			input.checked = true;
		}
	}
	
	if (input && wrapper) {
		console.log('✅ Valid swatch interaction detected');
		// Small delay to ensure radio button state updates
		setTimeout(() => {
			updateProductImage(wrapper, input);
		}, 10);
	}
}, true); // Use capture phase to catch events early

// Also listen for change events as backup
document.addEventListener('change', function(e) {
	if (e.target.matches('.js-color-swatches input[type="radio"]')) {
		console.log('🔄 Change event detected on input');
		const wrapper = e.target.closest('.js-color-swatches-wrapper');
		if (wrapper) {
			updateProductImage(wrapper, e.target);
		}
	}
}, true);

// Log initialization
console.log('✅ Event listeners attached to document');
console.log('🎬 Script ready - waiting for user interactions');

// Shopify section reload support
document.addEventListener("shopify:section:load", function() {
	console.log('🔄 Shopify section reloaded');
});